import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Accounts = props => (
  <SvgIcon viewBox="0 0 18.027 14.44" {...props}>
    <g id="wallet" transform="translate(0 -39)">
      <g id="Group_2592" data-name="Group 2592" transform="translate(16.786 48.046)">
        <g id="Group_2591" data-name="Group 2591" transform="translate(0 0)">
          <path id="Path_2538" data-name="Path 2538" d="M365.529,236.62a2.514,2.514,0,0,1-.529.483v2.06h.258a.983.983,0,0,0,.984-.975V235.7Z" transform="translate(-365 -235.7)" />
        </g>
      </g>
      <g id="Group_2594" data-name="Group 2594" transform="translate(0 40.931)">
        <g id="Group_2593" data-name="Group 2593" transform="translate(0 0)">
          <path id="Path_2539" data-name="Path 2539" d="M12.969,84.633h2.654a1.133,1.133,0,0,0,.244-.028V81.975a.976.976,0,0,0-.98-.975H.984A.983.983,0,0,0,0,81.975V92.52a1,1,0,0,0,.984.989h13.9a.988.988,0,0,0,.98-.989l0-2.672c-.078.009-.161.018-.244.023H12.969a2.619,2.619,0,0,1,0-5.238Z" transform="translate(0 -81)" />
        </g>
      </g>
      <g id="Group_2596" data-name="Group 2596" transform="translate(2.161 39)">
        <g id="Group_2595" data-name="Group 2595" transform="translate(0 0)">
          <path id="Path_2540" data-name="Path 2540" d="M61.882,39H47.98a.988.988,0,0,0-.98.989v.023H59.725a1.9,1.9,0,0,1,1.9,1.895v1.922l1.242-1.6v-2.24A1,1,0,0,0,61.882,39Z" transform="translate(-47 -39)" />
        </g>
      </g>
      <g id="Group_2598" data-name="Group 2598" transform="translate(11.272 43.732)">
        <g id="Group_2597" data-name="Group 2597">
          <path id="Path_2541" data-name="Path 2541" d="M251.851,141.9l-.713.92a2.139,2.139,0,0,1-.777.625,2.1,2.1,0,0,1-.915.207H246.8a1.7,1.7,0,0,0,0,3.4h2.654a1.238,1.238,0,0,0,.966-.478l1.439-1.867Zm-4.024,3.914h-1.1a.46.46,0,0,1,0-.92h1.1a.46.46,0,0,1,0,.92Z" transform="translate(-245.1 -141.9)" />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export default Accounts;
